import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { useRecoilState } from "recoil";

import { apiGetPlatformOptions } from "../../../lib/api/platform";
import { engageState } from "../../../atoms/platform";

import AgendasV2 from "../../../components/Engage/AgendasV2";
// import EngageSideBar from "../../../components/Layout/EngageSideBar";
// import EngageMenuButton from "../../../components/Layout/EngageMenuButton";

function useMounted() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
}

export default function EngageAgendas() {
  const isMounted = useMounted();
  const router = useRouter();
  const { client } = router.query;
  const [clientState, setClientState] = useRecoilState(engageState);

  useEffect(() => {
    async function fetchClient() {
      const results = await apiGetPlatformOptions(client);
      if (results) {
        setClientState(results);
      }
    }
    if (client) {
      if (!clientState) {
        fetchClient();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  return (
    <div className="h-screen flex overflow-hidden bg-white default-scrollbar">
      <div className="flex flex-col w-0 flex-1 overflow-hidden">
        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <div className="py-6">
            <div className="max-w-7xl 2xl:max-w-7/8 mx-auto px-4 sm:px-6 md:px-8">
              {isMounted && <AgendasV2 />}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
